/* ==== MM / Tooltip + Toggle — JS =========================================
   Desktop (hover possible)  : tooltip au survol de l'icône info.
   Mobile (pointer coarse)   : la même icône ouvre une bottom sheet.  */
   (function () {
	'use strict';
  
	function useSheet() {
	  return window.matchMedia('(hover: none)').matches || window.innerWidth < 750;
	}
  
	/* Le toggle est le COMPOSANT mm-form-control (checkbox natif role=switch) ;
	   l'ajout/retrait au panier au submit vit dans mm_cart.js. Ici : bascule du
	   prix affiché sur les CTA (mm-btn__price, data-price-with-accessory posé
	   par mm-product-cta.liquid / mm-sticky-cta.liquid) entre le prix produit
	   seul et le prix produit + accessoire, au (dé)cochage. */
	document.addEventListener('change', function (e) {
	  if (!e.target.matches('.mm-form-control__input[name="accessory"]')) return;
	  var checked = e.target.checked;
	  document.querySelectorAll('[data-price-with-accessory]').forEach(function (el) {
		var next = checked ? el.dataset.priceWithAccessory : el.dataset.priceBase;
		if (!next || el.textContent === next) return;
		el.textContent = next;
		if (window.MmMotion) MmMotion.pop(el);
	  });
	});
  
	/* Bulle "indisponible dans cette taille" : tap mobile (hover/focus en CSS).
	   Délégué sur document : le bloc accessoire est remplacé à chaque
	   changement de variante (data-product-reload). */
	document.addEventListener('click', function (e) {
	  var btn = e.target.closest('.mm-acc__unavailable-btn');
	  document.querySelectorAll('.mm-acc__unavailable.is-open').forEach(function (el) {
		if (!btn || el !== btn.parentElement) el.classList.remove('is-open');
	  });
	  if (btn) btn.parentElement.classList.toggle('is-open');
	});
	document.addEventListener('keydown', function (e) {
	  if (e.key !== 'Escape') return;
	  document.querySelectorAll('.mm-acc__unavailable.is-open').forEach(function (el) {
		el.classList.remove('is-open');
	  });
	});

	/* Positionnement intelligent : reste dans l'écran (décalage horizontal)
	   et bascule au-dessus de l'icône si le bas de l'écran est trop proche */
	function positionTip(tip) {
	  var icon = tip.querySelector('.mm-tip__icon');
	  var panel = tip.querySelector('.mm-tip__panel');
	  if (!icon || !panel) return;
  
	  var r = icon.getBoundingClientRect();
	  var vw = window.innerWidth;
	  var vh = window.innerHeight;
	  var panelW = panel.offsetWidth || 340;
	  var panelH = panel.offsetHeight || 140;
  
	  /* horizontal : ancre à -60px du centre de l'icône, borné aux bords */
	  var ml = -60;
	  var left = r.left + r.width / 2 + ml;
	  if (left + panelW > vw - 12) ml -= (left + panelW) - (vw - 12);
	  if (r.left + r.width / 2 + ml < 12) ml = 12 - (r.left + r.width / 2);
	  tip.style.setProperty('--tip-ml', ml + 'px');
	  tip.style.setProperty('--tip-ox', (-ml) + 'px');
  
	  /* vertical : au-dessus si pas la place en dessous (et assez au-dessus) */
	  var below = vh - r.bottom - 12;
	  var above = r.top - 12;
	  tip.classList.toggle('is-above', below < panelH && above > below);
	}
  
	/* Tooltip / bottom sheet */
	function bindTip(tip) {
	  if (tip.dataset.tipBound) return;
	  tip.dataset.tipBound = 'true';
	  var icon = tip.querySelector('.mm-tip__icon');
	  var sheetId = tip.getAttribute('data-sheet');
  
	  /* position initiale : sans ça, --tip-ml garde son défaut CSS (-60px) tant
		 qu'aucun hover/focus/click n'a eu lieu — le panneau (340px, caché mais
		 bien présent dans le flow) peut déborder à droite du viewport et
		 élargir le scroll horizontal sur mobile */
	  positionTip(tip);

	  /* repositionne avant chaque affichage (hover, focus ou clic) */
	  icon.addEventListener('mouseenter', function () { positionTip(tip); });
	  icon.addEventListener('focus', function () { positionTip(tip); });
  
	  tip.addEventListener('mouseleave', function () { tip.classList.remove('is-dismissed'); });
	  icon.addEventListener('blur', function () { tip.classList.remove('is-dismissed'); });

	  icon.addEventListener('click', function (e) {
		e.preventDefault();
		tip.classList.remove('is-dismissed');
		var sheet = sheetId ? document.getElementById(sheetId) : null;
		if (useSheet() && sheet) {
		  tip.classList.remove('is-open');
		  sheet.__mmOpener = icon;
		  sheet.classList.add('is-open');
		  var sheetClose = sheet.querySelector('.mm-sheet__close');
		  if (sheetClose) sheetClose.focus();
		} else {
		  positionTip(tip);
		  tip.classList.toggle('is-open');
		}
	  });
	}

	document.addEventListener('click', function (e) {
	  document.querySelectorAll('.mm-tip.is-open').forEach(function (tip) {
		if (!tip.contains(e.target)) tip.classList.remove('is-open');
	  });
	});
  
	/* en mobile, aucun tooltip flottant ne doit rester ouvert */
	function closeFloatingTips() {
	  if (useSheet()) {
		document.querySelectorAll('.mm-tip.is-open').forEach(function (tip) {
		  tip.classList.remove('is-open');
		});
	  }
	}
	closeFloatingTips();
	window.addEventListener('resize', closeFloatingTips);
  
	/* Fermeture des sheets */
	function closeSheet(sheet) {
	  if (!sheet.classList.contains('is-open')) return;
	  sheet.classList.remove('is-open');
	  var opener = sheet.__mmOpener;
	  sheet.__mmOpener = null;
	  if (opener && document.contains(opener)) opener.focus();
	}

	function bindSheet(sheet) {
	  if (sheet.dataset.sheetBound) return;
	  sheet.dataset.sheetBound = 'true';
	  sheet.querySelector('.mm-sheet__overlay').addEventListener('click', function () {
		closeSheet(sheet);
	  });
	  var close = sheet.querySelector('.mm-sheet__close');
	  if (close) close.addEventListener('click', function () {
		closeSheet(sheet);
	  });
	}

	function initTips() {
	  document.querySelectorAll('.mm-tip').forEach(bindTip);
	  document.querySelectorAll('.mm-sheet').forEach(bindSheet);
	}
	initTips();
	document.addEventListener('cart:refreshed', initTips);
	document.addEventListener('product:product-reload-complete', initTips);

	document.addEventListener('keydown', function (e) {
	  if (e.key !== 'Escape') return;
	  document.querySelectorAll('.mm-sheet.is-open').forEach(closeSheet);
	  document.querySelectorAll('.mm-tip').forEach(function (tip) {
		if (!tip.classList.contains('is-open') && !tip.matches(':hover') && !tip.contains(document.activeElement)) return;
		tip.classList.remove('is-open');
		tip.classList.add('is-dismissed');
	  });
	});
  })();  